import { forwardRef } from "react";

const TypingDots = () => (
  <div className="flex justify-start">
    <div className="bg-[#151515] text-zinc-400 border border-white/10 px-3 py-2 text-sm">
      <span className="inline-flex gap-1">
        <span className="w-1.5 h-1.5 bg-[#7CFF00] animate-bounce" />
        <span className="w-1.5 h-1.5 bg-[#7CFF00] animate-bounce [animation-delay:120ms]" />
        <span className="w-1.5 h-1.5 bg-[#7CFF00] animate-bounce [animation-delay:240ms]" />
      </span>
    </div>
  </div>
);

const MessageList = forwardRef(function MessageList({ messages, busy }, ref) {
  return (
    <div
      ref={ref}
      className="h-[360px] overflow-y-auto px-4 py-4 space-y-3 bg-[#0A0A0A]"
    >
      {messages.map((m, i) => (
        <div
          key={m.id}
          data-testid={`chat-msg-${m.role}-${i}`}
          className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}
        >
          <div
            className={`max-w-[80%] px-3 py-2 text-sm leading-relaxed ${
              m.role === "user"
                ? "bg-[#7CFF00] text-black"
                : "bg-[#151515] text-white border border-white/10"
            }`}
          >
            {m.content}
          </div>
        </div>
      ))}
      {busy && <TypingDots />}
    </div>
  );
});

export default MessageList;
